class InfiniteScroll extends HTMLElement {
  constructor() {
    super();

    this.observer = new IntersectionObserver(
      (entries, observer) => {
        const item = entries[0];

        if (item.intersectionRatio > 0) {
          const nextPage = Number(item.target.dataset.currentPage) + 1;
          if (nextPage > item.target.dataset.totalPages) return;

          this.renderNextPage(nextPage);
          item.target.dataset.currentPage = nextPage;
        }
      },
      { rootMargin: "0px 0px 500px 0px" }
    );

    this.observer.observe(this);
  }

  toggleLoading(show = false) {
    this.innerText = show ? "Loading more..." : "";
  }

  renderNextPage(page) {
    const section = document.getElementById("product-grid").dataset.id;
    const searchParams = new URLSearchParams(window.location.search);

    searchParams.append("page", page);

    const url = `${
      window.location.pathname
    }?section_id=${section}&${searchParams.toString()}`;

    this.toggleLoading(true);

    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        this.toggleLoading(false);
        const html = responseText;
        const destination = document.getElementById("product-grid");
        const source = new DOMParser()
          .parseFromString(html, "text/html")
          .querySelectorAll("#product-grid li");

        let fragment = new DocumentFragment();
        source.forEach((item) => fragment.appendChild(item));

        destination.append(fragment);

        // fix bug in Safari where srcset doesn't render correctly for images loaded asynchronously
        this.reloadSrcsetImgs(document);

        if (StampedFn) StampedFn.reloadUGC();
      })
      .catch(() => {
        this.toggleLoading(false);
      });
  }

  reloadSrcsetImgs(item) {
    var imgs = item.querySelectorAll("img[srcset]");
    for (var i = 0; i < imgs.length; i++) {
      var img = imgs[i];
      img.outerHTML = img.outerHTML;
    }
  }
}

customElements.define("infinite-scroll", InfiniteScroll);
